import { Component, Inject, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CommonService } from "projects/service/src/app/shared/services/common.service";

@Component({
    selector: 'app-leads-service-popup',
    templateUrl: './leads-service-popup.component.html',
    styleUrls: [
        './leads-service-popup.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LeadsServicePopupComponent {

    showIscBpLookup = false;
    company: string;
    serviceDepartment: string;
    @ViewChild('leadsPopupRef') leadsPopupRef: any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: any,
        private commonService: CommonService
      ){
        console.log(dialogData);
        (window as any).__serviceCommonService = this.commonService;
        const user = this.commonService.USER || this.commonService.getUSER();
        this.company = this.dialogData?.company || user?.company;
        this.serviceDepartment = this.dialogData?.serviceDepartment || user?.serviceDepartment;
      }

    onOpenIscBpLookup() {
      this.showIscBpLookup = true;
    }

    onCloseSearchForCustomer(event: any) {
      this.showIscBpLookup = false;
      if (event && this.leadsPopupRef) {
        this.leadsPopupRef.onCloseIscBpLookup(event);
      }
    }
}
